import React, { useEffect } from 'react'
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  EmailIcon,
  EmailShareButton,
  RedditIcon,
  RedditShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import { v4 as uuidv4 } from 'uuid'
import ReactPlayer from 'react-player'

import * as ambassadorSelectors from '../../../selectors'

interface AmbassadorChallengeDetailsProps extends FunctionsToProps {
  data: ChallengeDataRecord;
  onAfterSocialShare?: any;
  toggleModal?: () => void;
}

interface FunctionsToProps {
  getConvertedCurrencyValue: (value: number) => string;
  getDaysRemaining: (EndDate: string) => string;
  getPercentageFunded: (currentValue: number, goalvalue: number) => number;
}

export const AmbassadorChallengeDetails = (props: AmbassadorChallengeDetailsProps) => {
  const {
    ChallengeName,
    ChallengeStartDate,
    ChallengeEndDate,
    ChallengeDescription,
    NumberOfDonations,
    RaisedAmount,
    GoalAmount,
    GoalParticipation,
    ChallengeGoalType,
    DonationUrl,
    SocialShareUrl,
    CreateShareApiUrl,
    FacebookSnId,
    TwitterSnId,
    LinkedInSnId,
    RedditSnId,
    WhatsappSnId,
    EMailSnId,
    VideoFileUrl,
  } = props.data

  const {
    getConvertedCurrencyValue,
    getDaysRemaining,
    getPercentageFunded,
    onAfterSocialShare,
  } = props
  const daysRemaining = getDaysRemaining(ChallengeEndDate)
  const isDonateBtnDisabled =
    ambassadorSelectors.isDonateBtnDisabled(ChallengeStartDate)
  const swagIdFacebook = uuidv4()
  const swagIdTwitter = uuidv4()
  const swagIdLinkedIn = uuidv4();
  const swagIdEmail = uuidv4();
  const swagIdReddit = uuidv4();
  const swagIdWhatsapp = uuidv4();
  let FundedPercentage = 0
  if (ChallengeGoalType !== 'Participation') {
    FundedPercentage = getPercentageFunded(RaisedAmount, GoalAmount)
  } else {
    FundedPercentage = getPercentageFunded(
      NumberOfDonations,
      GoalParticipation
    )
  }

  //The below code is included to load the latest Twitter Icon however this code is not needed once library is updated
  useEffect(() => {
    const elements = document.querySelectorAll('[aria-label="twitter"]');

    elements.forEach((el) => {
      const elPath = el.getElementsByTagName('path')[0];
      const eLCircle = el.getElementsByTagName('circle')[0];

      if (el && eLCircle) {
        elPath && elPath.removeAttribute('d');
        elPath && elPath.setAttribute("d", "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z");

        eLCircle && eLCircle.removeAttribute('fill');
        eLCircle && eLCircle.setAttribute('fill', '#000000');
      }
    });
  }, []);

  return (
    <>
      <h4 className="Challengeheader">{ChallengeName}</h4>
      <div className="challenge-image-wrapper">
        <div className="defaultImg" />
      </div>
      <div className="challengeDetailsCnt">
        <span className="title">Description</span>
        <p className="textCnt">{ChallengeDescription}</p>
      </div>
      {VideoFileUrl && VideoFileUrl !== '' && (
        <div className="challengeDetailsCnt">
          <span className="title">Video</span>
          <div className="challenge-video-wrapper">
            <ReactPlayer url={VideoFileUrl} />
          </div>
        </div>
      )}

      <div className="challenge-popup-card-border">
        <div className="challengeDetailsCnt">
          <span className="title">Progress</span>
          <div className="socialShareCnt">
            <FacebookShareButton
              className="socialShareBtn facebookBtn"
              onShareWindowClose={
                onAfterSocialShare &&
                onAfterSocialShare.bind(
                  null,
                  `${CreateShareApiUrl}&swag=${swagIdFacebook}&sn=${FacebookSnId}`
                )
              }
              quote={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdFacebook}&sn=${FacebookSnId}`}
            >
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            <TwitterShareButton
              className="socialShareBtn twitterBtn"
              onShareWindowClose={
                onAfterSocialShare &&
                onAfterSocialShare.bind(
                  null,
                  `${CreateShareApiUrl}&swag=${swagIdTwitter}&sn=${TwitterSnId}`
                )
              }
              title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdTwitter}&sn=${TwitterSnId}`}
            >
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
            <LinkedinShareButton
              className="socialShareBtn"
              onShareWindowClose={() => {
                if (onAfterSocialShare)
                  onAfterSocialShare(
                    `${CreateShareApiUrl}&swag=${swagIdLinkedIn}&sn=${LinkedInSnId}`
                  );
              }}
              title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdLinkedIn}&sn=${LinkedInSnId}`}
            >
              <LinkedinIcon size={32} round={true} />
            </LinkedinShareButton>
            <RedditShareButton
              className="socialShareBtn"
              onShareWindowClose={() => {
                if (onAfterSocialShare)
                  onAfterSocialShare(
                    `${CreateShareApiUrl}&swag=${swagIdReddit}&sn=${RedditSnId}`
                  );
              }}
              title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdReddit}&sn=${RedditSnId}`}
            >
              <RedditIcon size={32} round={true} />
            </RedditShareButton>
            <WhatsappShareButton
              className="socialShareBtn"
              onShareWindowClose={() => {
                if (onAfterSocialShare)
                  onAfterSocialShare(
                    `${CreateShareApiUrl}&swag=${swagIdWhatsapp}&sn=${WhatsappSnId}`
                  );
              }}
              title={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdWhatsapp}&sn=${WhatsappSnId}`}
            >
              <WhatsappIcon size={32} round={true} />
            </WhatsappShareButton>
            <EmailShareButton
              className="socialShareBtn"
              onShareWindowClose={() => {
                if (onAfterSocialShare)
                  onAfterSocialShare(
                    `${CreateShareApiUrl}&swag=${swagIdEmail}&sn=${EMailSnId}`
                  );
              }}
              subject={`Help me meet my Donation Challenge: ${ChallengeName}`}
              body={`Hey friends! Help me make a difference by contributing to ${ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
              url={`${SocialShareUrl}&swag=${swagIdEmail}&sn=${EMailSnId}`}
            >
              <EmailIcon size={32} round={true} />
            </EmailShareButton>
          </div>
          <div style={{ marginTop: '12px' }}>
            <div className="progressbar">
              <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow={FundedPercentage}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{ width: `${FundedPercentage}%` }}
              >
                <span className="sr-only">{FundedPercentage}% Complete</span>
              </div>
            </div>
          </div>
          <div style={{ padding: '0px' }}>
            <ul id="summary" className="challenge-details-wrapper">
              <li className="challengeDetails">
                <p className="detailsTitle">{FundedPercentage}%</p>
                <p className="detailsDescription">Funded</p>
              </li>
              <li className="challengeDetails">
                <p className="detailsTitle">{NumberOfDonations}</p>
                <p className="detailsDescription">Donors</p>
              </li>
              <li className="challengeDetails">
                {daysRemaining === '0 Minutes' && (
                  <span className="ribbon red">Ended</span>
                )}
                <p className="detailsTitle">{daysRemaining}</p>
                <p className="detailsDescription">Remaining</p>
              </li>
              <li className="challengeDetails">
                <p className="detailsTitle">
                  ${getConvertedCurrencyValue(RaisedAmount)}
                </p>
                <p className="detailsDescription">Raised</p>
              </li>
              <li className="challengeDetails">
                {FundedPercentage === 100 && (
                  <span className="ribbon green">Achieved</span>
                )}
                {ChallengeGoalType !== 'Participation' ? (
                  <p className="detailsTitle">
                    ${getConvertedCurrencyValue(GoalAmount)}
                  </p>
                ) : (
                  <p className="detailsTitle">
                    {GoalParticipation}{' '}
                    <span className="detailsDescription">donors</span>
                  </p>
                )}
                <p className="detailsDescription">Goal</p>
              </li>
              <li className="btndiv">
                <button
                  className="button donateBtn"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  disabled={isDonateBtnDisabled}
                >
                  <a href={DonationUrl} target="_blank" rel="noreferrer">
                    {' '}
                    DONATE{' '}
                  </a>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
